class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    const parentElement = document.querySelector('.collection-drawer-collapse-left');
    this.drawerCollapse(parentElement);
    FacetFiltersForm.animDetails();
    FacetFiltersForm.scrollUX();
  }
  /* custom open drawer */
  drawerCollapse(parentElement) {
    if(parentElement){
      const btnOpen = this.querySelector('.drawer-collapse-btn');
      const sideBar = parentElement.querySelector('.sidebar-collapse-left');
      const btnClose = sideBar.querySelector('.btn-close-sidebar-collapse');
      if (!btnOpen || !parentElement || !sideBar || !btnClose) {
        return;
      }
      btnOpen.addEventListener('click', function() {
        btnOpen.classList.toggle('open');
        sideBar.classList.toggle('open');
      });
    
      btnClose.addEventListener('click', function() {
        btnOpen.classList.remove('open');
        sideBar.classList.remove('open');
      });
    }
  }
  static scrollUX(){
    document.querySelectorAll('.facet-checkbox').forEach((facets__checkbox) => {
      facets__checkbox.addEventListener('click', (event) => {
        const headerHeight = document.querySelector('header').offsetHeight;
        const mainCollection = document.querySelector('.main-collection');
        const scrollPosition = mainCollection.getBoundingClientRect().top + window.scrollY - headerHeight;
        window.scrollTo({
          top: scrollPosition,
          behavior: 'smooth'
        });
      });
    });    
  }
  static animDetails(){
    class Accordion {
      constructor(el) {
        this.el = el;
        this.summary = el.querySelector('.facets__summary');
        this.content = el.querySelector('.facets__display-vertical');
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.summary.addEventListener('click', (e) => this.onClick(e));
      }
    
      onClick(e) {
        e.preventDefault();
        this.el.style.overflow = 'hidden';
        if (this.isClosing || !this.el.open) {
          this.open();
        } else if (this.isExpanding || this.el.open) {
          this.shrink();
        }
      }
    
      shrink() {
        this.isClosing = true;
        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight}px`;
    
        if (this.animation) {
          this.animation.cancel();
        }
    
        this.animation = this.el.animate({
          height: [startHeight, endHeight]
        }, {
          duration: 300,
          easing: 'ease'
        });
    
        this.animation.onfinish = () => this.onAnimationFinish(false);
        this.animation.oncancel = () => this.isClosing = false;
      }
    
      open() {
        this.el.style.height = `${this.el.offsetHeight}px`;
        this.el.open = true;
        window.requestAnimationFrame(() => this.expand());
      }
    
      expand() {
        this.isExpanding = true;
        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    
        if (this.animation) {
          this.animation.cancel();
        }
    
        this.animation = this.el.animate({
          height: [startHeight, endHeight]
        }, {
          duration: 300,
          easing: 'ease'
        });
    
        this.animation.onfinish = () => this.onAnimationFinish(true);
        this.animation.oncancel = () => this.isExpanding = false;
      }
    
      onAnimationFinish(open) {
        this.el.open = open;
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.el.style.height = this.el.style.overflow = '';
      }
    }
    
    document.querySelectorAll('.facets__disclosure-vertical').forEach((el) => {
      new Accordion(el);
    });
    
  }
  static closeDrawer(parentElement){
    if(parentElement){
      const btnOpen = parentElement.querySelector('.drawer-collapse-btn');
      const sideBar = parentElement.querySelector('.sidebar-collapse-left');
      const btnClose = sideBar.querySelector('.btn-close-sidebar-collapse');
      btnClose.addEventListener('click', function() {
        btnOpen.classList.remove('open');
        sideBar.classList.remove('open');
      });
    }
   
  }
  
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static mergeCollectionSizeParam(searchParams) {
    // Keep ?size=50ml|18ml|100ml across sort/price AJAX — Shopify Liquid often
    // omits custom query params from section HTML, so the browser URL is the source of truth.
    try {
      const current = new URLSearchParams(window.location.search);
      const size = current.get('size');
      if (!size) return searchParams || '';
      const next = new URLSearchParams(searchParams || '');
      if (!next.get('size')) next.set('size', size);
      return next.toString();
    } catch (err) {
      return searchParams || '';
    }
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    searchParams = FacetFiltersForm.mergeCollectionSizeParam(searchParams);
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer) {
      const collectionEl = gridContainer.querySelector('.collection');
      if (collectionEl) collectionEl.classList.add('loading');
      else gridContainer.classList.add('loading');
    }
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    // Always fetch fresh section HTML so price / size filters aren't served from a stale cache
    FacetFiltersForm.filterData = [];

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    
    
  }
  static renderReview() {
    if (window.SPR && theme.review ) {
      if ($('.shopify-product-reviews-badge').length > 0) {
        return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
      };
    }
    if(theme.review && typeof jdgm !== 'undefined' ){
      return jdgm.customizeBadges();
    }
    
  }
  static renderProductGridContainer(html) {
    const destination = document.getElementById('ProductGridContainer');
    const source = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');
    if (!destination || !source) return;
    destination.innerHTML = source.innerHTML;
    destination.classList.remove('loading');
    if (typeof window.nbThemeBoot === 'function') window.nbThemeBoot();
    if (typeof window.nbApplyCollectionSize === 'function') window.nbApplyCollectionSize();
  }

  static renderProductCount(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const sourceCount = parsed.getElementById('ProductCount');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (sourceCount && container) {
      container.innerHTML = sourceCount.innerHTML;
      container.classList.remove('loading');
    }
    if (sourceCount && containerDesktop) {
      containerDesktop.innerHTML = sourceCount.innerHTML;
      containerDesktop.classList.remove('loading');
    }
    const getpagi = document.querySelector('.AjaxinatePagination');
    if (typeof(getpagi) !== "undefined" && getpagi !== null) {
      const elem = getpagi.getAttribute('data-pagination');
      if (typeof Ajaxinate !== 'undefined') {
        new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click',
          callback: function () {
            if (typeof jdgm !== 'undefined') jdgm.customizeBadges();
          }
        });
      }
    }
    try {
      if (window.theme) {
        if (theme.wishlist && typeof theme.wishlist.load === 'function') theme.wishlist.load();
        if (theme.compare && typeof theme.compare.load === 'function') theme.compare.load();
        if (theme.swatchCard2 && typeof theme.swatchCard2.load === 'function') theme.swatchCard2.load();
        if (theme.tooltip && typeof theme.tooltip.load === 'function') theme.tooltip.load();
      }
      FacetFiltersForm.renderReview();
    } catch (err) {}
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const destination = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (destination) destination.innerHTML = element.innerHTML;
    });

    try {
      FacetFiltersForm.renderActiveFacets(parsedHTML);
      FacetFiltersForm.renderAdditionalElements(parsedHTML);
      FacetFiltersForm.scrollUX();
      FacetFiltersForm.animDetails();
    } catch (err) {}

    if (countsToRender) {
      const targetFilter = event && event.target && event.target.closest
        ? event.target.closest('.js-filter')
        : null;
      if (targetFilter) FacetFiltersForm.renderCounts(countsToRender, targetFilter);
    }
    
    const parentElement = document.querySelector('.collection-drawer-collapse-left');
    if (parentElement) FacetFiltersForm.closeDrawer(parentElement);


  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const destination = document.querySelector(selector);
      if (!activeFacetsElement || !destination) return;
      destination.innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const destination = document.querySelector(selector);
      if (!destination) return;
      destination.innerHTML = html.querySelector(selector).innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm) {
      const drawer = mobileForm.closest('menu-drawer');
      if (drawer && typeof drawer.bindEvents === 'function') drawer.bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const grid = document.getElementById('product-grid');
    const filters = document.getElementById('main-collection-filters');
    const sectionId = (grid && grid.dataset.id) || (filters && filters.dataset.id);
    if (!sectionId) return [];
    return [{ section: sectionId }];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }
  

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
  
    this.setMinAndMaxValues();
    this.noUifilter();
  }
  connectedCallback(){
    this.noUifilter();
  }
  onRangeChange(event) {
   
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    this.noUifilter();
    
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
  

  noUifilter() {
    var sliderRange = this.querySelector(".slider-range");
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    var minValue = parseFloat(minInput.value);
    if (isNaN(minValue)) {
      minValue = 0;
    }
  
    var event = new CustomEvent('input');
    var form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    if (!sliderRange.classList.contains("noUi-target")) {
      noUiSlider.create(sliderRange, {
        start: [minValue, maxInput.value === '' ? parseFloat(maxInput.getAttribute('max')) : parseFloat(maxInput.value)],
        connect: true,
        step: 1,
        range: {
          'min': 0,
          'max': parseFloat(maxInput.getAttribute('max'))
        }
      });
      sliderRange.noUiSlider.on("change", function(values, handle) {
        if (handle === 0) {
          minInput.value = values[handle];
        }
        if (handle === 1) {
          maxInput.value = values[handle];
        }
      });
      sliderRange.noUiSlider.on('change', function(values) {
        form.querySelector('form').dispatchEvent(event);
      });
  
      minInput.addEventListener('change', function() {
        var minValue = parseFloat(minInput.value);
        setTimeout(function() {
          sliderRange.noUiSlider.set([minValue, null]);
        }, 0);
      });
  
      maxInput.addEventListener('change', function() {
        var maxValue = parseFloat(maxInput.value);
        setTimeout(function() {
          sliderRange.noUiSlider.set([null, maxValue]);
        }, 0);
      });
    }
  }
  

}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
    
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

